import React from 'react';
import { Alert, Card, Container } from 'reactstrap';
import { useSelector } from 'react-redux';
import { object } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  profile: object.isRequired,
};

const defaultProps = {
  profile: {},
};

const BlockedUserMessage = () => {
  const profile = useSelector(state => state.webmaster.profile);
  return profile && profile.banned ? (
    <Container>
      <Card>
        <Alert color="danger" className="no-margin no-border" fade={false}>
          <h6>
            <FMessage id="user.blocked.header" />
          </h6>
          <p>
            <FMessage id="user.blocked.p-1" />
          </p>
          <p>
            <FMessage id="user.blocked.p-2" />
          </p>
          <p>
            <FMessage id="user.blocked.p-3" />
          </p>
          <p>
            <FMessage id="user.blocked.p-4" />
          </p>
        </Alert>
      </Card>
    </Container>
  ) : null;
};

BlockedUserMessage.propTypes = propTypes;
BlockedUserMessage.defaultProps = defaultProps;

export default BlockedUserMessage;
